import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Templates() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/templates").then((r) => setItems(r.data)); }, []);

  return (
    <div data-testid="templates-page">
      <div className="kbar">Plantillas</div>
      <h1 className="font-display font-extrabold text-3xl sm:text-5xl tracking-tight mt-2">8 oficios</h1>
      <p className="text-slate-500 mt-2">Pulsa una plantilla para abrir el generador con valores ya predefinidos.</p>

      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
        {items.map((t) => (
          <Link key={t.id} to={`/generator?template=${t.id}`} data-testid={`tpl-card-${t.id}`}
            className="bg-white p-6 hover:bg-slate-50 transition-colors group">
            <div className="w-10 h-10 flex items-center justify-center text-white font-bold" style={{ background: t.color }}>
              {t.name[0]}
            </div>
            <div className="mt-4 font-display font-bold text-lg">{t.name}</div>
            <div className="text-sm text-slate-500 mt-1">{t.description}</div>
            <div className="mt-3 text-sm text-slate-400">Tarifa orientativa: <span className="font-bold text-slate-700">{t.default_rate} €/h</span></div>
            <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-orange-600 group-hover:gap-2 transition-all">Usar plantilla <ArrowRight className="w-4 h-4" /></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
